export const availibleResultSelection = [
  { urlResult: 'eye', text: 'Eye', index: '0' },
  { urlResult: 'droneVision', text: 'DroneVision', index: '1' },
  { urlResult: 'eye4SDK', text: 'Глаз (4 SDK)', index: '2' },
  { urlResult: 'eye3', text: 'Глаз 3', index: '3' },
  { urlResult: 'eyeLite', text: 'Глаз Lite', index: '4' },
  { urlResult: 'droneDetector', text: 'Drone Detector', index: '5' },
  { urlResult: 'berry', text: 'Berry', index: '6' },
  { urlResult: 'sova', text: 'СОВА', index: '7' },
];
